module.exports = __webpack_public_path__ + "428a35e9f49649efcb41b7ecacc06b5f.pdf";